function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Vrstva_3"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Vrstva_2"
}, React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M146.572,464.052c0-25.971,6.151-41.234,30.527-41.234c24.376,0,30.527,15.036,30.527,41.234 c0,27.565-6.037,40.551-30.527,40.551C152.496,504.604,146.572,490.479,146.572,464.052z M203.298,464.052 c0-23.579-4.784-37.361-26.198-37.361c-21.643,0-26.199,13.555-26.199,37.361c0,23.92,4.214,36.678,26.199,36.678 C199.083,500.73,203.298,489.112,203.298,464.052z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M224.028,503.578v-56.954h3.987v4.557c0,0,10.138-5.582,19.934-5.582c15.492,0,18.681,6.265,18.681,28.363 v29.616h-3.986V474.19c0-19.364-2.05-24.945-14.694-24.945c-10.138,0-19.934,5.695-19.934,5.695v48.638H224.028z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M725.572,463.052c0-25.971,6.15-41.234,30.527-41.234c24.376,0,30.527,15.036,30.527,41.234 c0,27.565-6.037,40.551-30.527,40.551C731.496,503.604,725.572,489.479,725.572,463.052z M782.298,463.052 c0-23.579-4.784-37.361-26.198-37.361c-21.643,0-26.199,13.555-26.199,37.361c0,23.92,4.215,36.678,26.199,36.678 S782.298,488.112,782.298,463.052z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M809.18,502.578h-3.986V449.27h-7.86v-3.645h7.86v-6.948c0-16.402,4.1-20.275,14.465-20.275 c3.987,0,10.48,0.342,10.48,0.342v3.531c0,0-7.291-0.228-10.48-0.228c-7.745,0-10.479,3.076-10.479,16.744v6.834h18.453v3.645 H809.18V502.578z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M844.831,502.578h-3.986V449.27h-7.86v-3.645h7.86v-6.948c0-16.402,4.101-20.275,14.466-20.275 c3.986,0,10.479,0.342,10.479,0.342v3.531c0,0-7.29-0.228-10.479-0.228c-7.746,0-10.479,3.076-10.479,16.744v6.834h18.453v3.645 h-18.453V502.578z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M375.648,267.843h8.657l28.021,73.47l28.021-73.47h8.657v79.735h-4.101v-75.862h-1.595l-28.021,73.47 h-5.923l-28.021-73.47h-1.595v75.862h-4.101V267.843z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M507.781,343.933l0.227,3.645c0,0-12.757,1.025-21.072,1.025c-16.972-0.114-21.415-10.935-21.415-29.502 c0-22.554,10.024-29.502,23.009-29.502c14.011,0,21.643,7.632,21.643,27.337v3.759h-40.437c0,15.719,4.101,24.262,17.313,24.262 C495.023,344.958,507.781,343.933,507.781,343.933z M505.958,317.051c0-17.428-5.582-23.807-17.428-23.807 c-11.391,0-18.794,6.493-18.794,23.807H505.958z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M525.096,347.578v-56.954h3.986v4.557c0,0,10.138-5.582,19.934-5.582c15.492,0,18.681,6.265,18.681,28.363 v29.616h-3.986V318.19c0-19.364-2.051-24.945-14.694-24.945c-10.138,0-19.934,5.695-19.934,5.695v48.638H525.096z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M625.902,290.625v56.954h-3.986v-4.556c0,0-8.885,5.582-18.681,5.582 c-15.491,0-18.681-6.265-18.681-28.363v-29.616h3.986v29.388c0,19.364,2.051,24.946,14.694,24.946 c10.138,0,18.681-5.696,18.681-5.696v-48.638H625.902z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M304,497v156c0,9.112,7.387,16.5,16.5,16.5S337,662.112,337,653V497c0-9.113-7.387-16.5-16.5-16.5 S304,487.887,304,497"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M268,609h469c3.313,0,6-2.687,6-6s-2.687-6-6-6H268c-3.313,0-6,2.687-6,6S264.687,609,268,609"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/custom-menu-on.654bedda.svg";
export { SvgComponent as ReactComponent };